import { render, staticRenderFns } from "./UpsiReviewDialog.vue?vue&type=template&id=16f7fe62"
import script from "./UpsiReviewDialog.vue?vue&type=script&lang=js"
export * from "./UpsiReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports